import script from "./2FASetup.vue?vue&type=script&setup=true&lang=js"
export * from "./2FASetup.vue?vue&type=script&setup=true&lang=js"

import "./2FASetup.vue?vue&type=style&index=0&id=19a6875f&scoped=true&lang=less"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-19a6875f"]])

export default __exports__